import React, { memo, useEffect, useState } from 'react';
import Dialog from '../../components/Dialog/Dialog';
import styles from './Message.module.less';
import { setMessageVisible } from '../../actions/layout';
import { useDispatch, useSelector } from 'react-redux';
import { setMessageActiveTab } from '../../actions/layout';
import { createSelector } from 'reselect';
import Comment from '../../pages/Message/Comment/Comment';
import Collect from '../../pages/Message/Collect/Collect';
import {
  getMessageList,
  resetMessageList,
  deleteMessageHot,
  getMessageHot,
} from '../../actions/message';
import Login from '../../static/message_login.svg';
import Default from '../../static/message_default.svg';
import Btn from '../../components/Btn/Btn';
import Loading from '../../components/Loading/Loading';
import { logging, logPostInfo } from '../../actions/log';
import useLoginStatus from '../../utils/hooks/useLoginStatus';
import Invite from '../../pages/Message/Invite/Invite';
import Sys from '../../pages/Message/Sys/Sys';
import { getQueryString } from '../../utils/utils';

const selectMessageLayout = createSelector(
  state => state.layout,
  layout => ({
    activeTab: layout.messageActiveTab,
  }),
);

const selectMessage = createSelector(
  state => state.message,
  message => ({
    commentList: message.commentList,
    collectList: message.collectList,
    inviteList: message.inviteList,
    sysList: message.sysList,
    hot: message.hot,
    commentLoading: message.commentLoading,
    collectLoading: message.collectLoading,
    inviteLoading: message.inviteLoading,
    sysLoading: message.sysLoading,
  }),
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const sourceTab = {
  comment: 'Message_Comment',
  collect: 'Message_Collect',
  invite: 'Message_Respond',
  sys: 'Message_Sys',
};
export default memo(() => {
  const dispatch = useDispatch();
  const { activeTab } = useSelector(selectMessageLayout);
  const logInfoData = useSelector(selectLogInfo);
  const loginStatus = useLoginStatus();

  const {
    commentList = [],
    collectList = [],
    inviteList = [],
    sysList = [],
    hot,
    commentLoading,
    collectLoading,
    inviteLoading,
    sysLoading,
  } = useSelector(selectMessage);

  const [initTime, setInitTime] = useState(+new Date());
  const logPV = () => {
    let p = logInfoData.source;
    let pp = logInfoData.source_p;
    dispatch(
      logging({
        category: 'P',
        action: `Message`,
        label: '',
        param2: {
          source: `Message`,
          source_p: p,
          source_pp: pp,
          activeTab: sourceTab[activeTab] || `Message`,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: sourceTab[activeTab],
        source_p: p,
        source_pp: pp,
      }),
    );
  };

  const leaveTimeLog = () => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Message`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  };
  useEffect(() => {
    setInitTime(Date.now());
    logPV();
    return () => {
      leaveTimeLog();
    };
  }, []);

  const handleClose = () => {
    dispatch(setMessageVisible(false));
    dispatch(resetMessageList());
  };

  useEffect(() => {
    if (Object.keys(hot)?.length === 0) {
      dispatch(getMessageHot());
    }
  }, [hot]);

  useEffect(() => {
    if (hot[1] === '1') {
      dispatch(setMessageActiveTab('comment'));
      return;
    }
    if (hot[2] === '1') {
      dispatch(setMessageActiveTab('collect'));
      return;
    }
    if (hot[4] === '1') {
      dispatch(setMessageActiveTab('invite'));
      return;
    }
    if (hot[5] === '1') {
      dispatch(setMessageActiveTab('sys'));
      return;
    }
  }, []);

  useEffect(() => {
    if (!loginStatus) {
      dispatch(resetMessageList());
      return;
    }
    if (activeTab === 'comment' && commentList.length === 0) {
      dispatch(deleteMessageHot({ code: 1 }));
      dispatch(getMessageList({ code: 1, refresh: true, skip: 0, limit: 24 }));
    }
    if (activeTab === 'collect' && collectList.length === 0) {
      dispatch(deleteMessageHot({ code: 2 }));
      dispatch(getMessageList({ code: 2, refresh: true, skip: 0, limit: 24 }));
    }
    if (activeTab === 'invite' && inviteList.length === 0) {
      dispatch(deleteMessageHot({ code: 4 }));
      dispatch(getMessageList({ code: 4, refresh: true, skip: 0, limit: 24 }));
    }
    if (activeTab === 'sys' && sysList.length === 0) {
      dispatch(deleteMessageHot({ code: 5 }));
      dispatch(getMessageList({ code: 5, refresh: true, skip: 0, limit: 24 }));
    }
  }, [activeTab, loginStatus]);

  // 根据url 上的参数选择是哪一个tab  主要服务与commline
  useEffect(() => {
    const defTab = getQueryString('tab') || '';
    if (defTab) {
      handleClickTab(defTab)();
    }
  }, []);

  const handleClickTab = tab => () => {
    const p = logInfoData.source;
    const pp = logInfoData.source_p;
    // 改变source
    if (activeTab !== tab) {
      dispatch(
        logPostInfo({
          source: sourceTab[tab],
          source_p: p,
          source_pp: pp,
        }),
      );
    }
    dispatch(setMessageActiveTab(tab));
    dispatch(
      logging({
        category: 'C',
        action: 'Message_Tab',
        label: '',
        param2: {
          source: sourceTab[tab],
          source_p: p,
          source_pp: pp,
          type: tab === 'invite' ? 'response' : tab,
        },
      }),
    );
  };

  const handelLogin = () => {
    // eslint-disable-next-line no-unused-expressions
    window && window.CallNativeMethod && window.CallNativeMethod('login');
  };
  return (
    <Dialog
      title={'消息中心'}
      maskStyle={styles.mask}
      containerStyle={styles.mask_container}
      handleClose={handleClose}
    >
      <div className={styles.content_container}>
        <div className={styles.header}>
          <div
            className={`${activeTab === 'comment' ? styles.active : ''} ${styles.item}`}
            onClick={handleClickTab('comment')}
          >
            评论与回复
            {hot && hot[1] === '1' && <div className={styles.hot} />}
          </div>
          <div
            className={`${activeTab === 'collect' ? styles.active : ''} ${styles.item}`}
            onClick={handleClickTab('collect')}
          >
            收藏与点赞
            {hot && hot[2] === '1' && <div className={styles.hot} />}
          </div>
          <div
            className={`${activeTab === 'invite' ? styles.active : ''} ${styles.item}`}
            onClick={handleClickTab('invite')}
          >
            邀请回答
            {hot && hot[4] === '1' && <div className={styles.hot} />}
          </div>
          <div
            className={`${activeTab === 'sys' ? styles.active : ''} ${styles.item}`}
            onClick={handleClickTab('sys')}
          >
            系统消息
            {hot && hot[5] === '1' && <div className={styles.hot} />}
          </div>
        </div>
        <div className={styles.content}>
          {!loginStatus && (
            <div className={styles.login}>
              <img src={Login} />
              <div className={styles.login_text}>登录后，查看我的消息</div>
              <Btn className={styles.login_btn} primary handleClick={handelLogin}>
                登录
              </Btn>
            </div>
          )}
          {loginStatus && (
            <>
              {((activeTab === 'comment' &&
                !commentLoading &&
                commentList &&
                commentList.length === 0) ||
                (activeTab === 'collect' &&
                  !collectLoading &&
                  collectList &&
                  collectList.length === 0) ||
                (activeTab === 'invite' &&
                  !inviteLoading &&
                  inviteList &&
                  inviteList.length === 0) ||
                (activeTab === 'sys' && !sysLoading && sysList && sysList?.length === 0)) && (
                <div className={styles.nodata}>
                  <img src={Default} />
                  <div className={styles.default_text}>啊哦，当前您尚未收到任何消息</div>
                </div>
              )}
              {((activeTab === 'comment' &&
                commentLoading &&
                commentList &&
                commentList.length === 0) ||
                (activeTab === 'collect' &&
                  collectLoading &&
                  collectList &&
                  collectList.length === 0) ||
                (activeTab === 'invite' &&
                  inviteLoading &&
                  inviteList &&
                  inviteList.length === 0) ||
                (activeTab === 'sys' && sysLoading && sysList && sysList.length === 0)) && (
                <div className={styles.loading}>
                  <Loading />
                </div>
              )}
            </>
          )}

          {loginStatus && (
            <>
              {activeTab === 'comment' && <Comment />}
              {activeTab === 'collect' && <Collect />}
              {activeTab === 'invite' && <Invite />}
              {activeTab === 'sys' && <Sys />}
            </>
          )}
        </div>
      </div>
    </Dialog>
  );
});
